<template>
  <div>
    <transition :name="transitionName">
	    <router-view class="Router" />
    </transition>
	<van-tabbar v-model="mIndex" @change='tabIndexChange'>
      <van-tabbar-item v-for="(item,index) in tabbars" :key="index" :to="(item.name)">
        <span>{{item.title}}</span>
        <img slot="icon" slot-scope="props" :src="props.active ? item.active : item.normal">
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'

export default {
  name: 'home',
  components: {
    
  },
  data() {
    return {
    tabbars: [
        {
          name: "/index",
          title: "首页",
          normal: require("./../../static/index.png"),
          active: require("./../../static/indexHL.png"),
        },
        {
          name: "/farm",
          title: "农场",
          normal: require("./../../static/farm.png"),
          active: require("./../../static/farmHL.png"),
        },
        {
          name: "/agronomy",
          title: "农艺",
          normal: require("./../../static/agriculture.png"),
          active: require("./../../static/agricultureHL.png"),
        },
        {
          name: "/my",
          title: "我的",
          normal: require("./../../static/my.png"),
          active: require("./../../static/myHL.png"),
        }
      ],
    transitionName:'slide-right'
    }
  },
  computed: {
    ...mapState(['meanIndex','isBack']),
    mIndex:{
      get () {
        return this.meanIndex
      },
      set (val) {
        this.$store.commit('setMeanIndex', val)
      }
    }
  },
  watch: {
      $route(to, from) {
        // 切换动画
        let isBack = this.$router.isBack // 监听路由变化时的状态为前进还是后退
        if (isBack) {
          this.transitionName = 'slide-left'
        } else {
          this.transitionName = 'slide-right'
        }
        this.$router.isBack = false
      }
    },
  mounted() {
   
  },
  methods: {
    ...mapMutations(['setMeanIndex','setIsBack']),
    tabIndexChange(index){
      this.setMeanIndex(index)
      if (!index == 1) {
          this.setIsBack(false)
      }
    }
  },
}
</script>
<style scoped>

</style>